import React from 'react';
import { HeartOffIcon } from 'lucide-react';
import { AppShell } from '../../components/layout/AppShell';
import { EmptyState } from '../../components/ui/Panels';
import { ButtonLink } from '../../components/ui/Button';
import { ChefCard } from '../../components/chefs/ChefCard';
import { useAppData } from '../../contexts/AppDataContext';
import { chefById } from '../../data/chefs';
export function Saved() {
  const {
    savedChefIds
  } = useAppData();
  const saved = savedChefIds.map(id => chefById(id)).filter(Boolean);
  return <AppShell title="Saved chefs" subtitle={`${saved.length} shortlisted`} actions={<ButtonLink to="/discover" variant="action" size="sm" data-id="element-1943" data-mp="3qd2btayh49zx">
          Find more
        </ButtonLink>} data-id="element-1942" data-mp="3bg1jb58gkb0e">
      {saved.length ? <ul className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3" data-id="element-1944" data-mp="15l9z5rqdlqry">
          {saved.map(chef => <li key={chef!.id} data-id="element-1945" data-mp="10myml98p5261">
              <ChefCard chef={chef!} data-id="element-1946" data-mp="10lnjzcqzm0gi" />
            </li>)}
        </ul> : <EmptyState icon={<HeartOffIcon className="h-5 w-5" aria-hidden="true" data-id="element-1948" data-mp="21bk2ni44w5mc" />} title="Nothing saved yet" body="Tap the heart on any chef to keep them here while you decide." action={<ButtonLink to="/discover" data-id="element-1949" data-mp="2bahlc4evp4xf">Browse chefs</ButtonLink>} data-id="element-1947" data-mp="21aqtkahpd411" />}
    </AppShell>;
}